(function () {
  if (window.Shopify && Shopify.designMode) {
    return;
  }

  const configElement = document.getElementById('tab-title-promo-config');

  if (!configElement) {
    return;
  }

  let config = null;

  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (_error) {
    return;
  }

  if (!config || config.enabled !== true) {
    return;
  }

  const originalTitle = document.title;
  const intervalMs = Number(config.intervalMs) || 3000;
  const startDelayMs = 5000;
  let titleInterval = null;
  let titleStartTimeout = null;
  let titleIndex = 0;

  function getCartCount() {
    const bubbleCount = document.querySelector('[data-testid="cart-bubble"]');

    if (bubbleCount instanceof HTMLElement) {
      const visibleCount = parseInt((bubbleCount.textContent || '').trim(), 10);

      if (!Number.isNaN(visibleCount)) {
        return visibleCount;
      }
    }

    try {
      const storedCount = sessionStorage.getItem('cart-count');

      if (storedCount) {
        const parsed = JSON.parse(storedCount);
        const value = parseInt(parsed.value, 10);

        if (!Number.isNaN(value)) {
          return value;
        }
      }
    } catch (_error) {
      // no-op
    }

    return Number(config.cartCount) || 0;
  }

  function getHiddenTitles() {
    const primaryText = (config.primaryText || 'Come back! 👀').trim();
    const secondaryText = (
      getCartCount() > 0 ? config.cartText || 'Your cart is waiting...' : config.emptyText || 'Cheap Roblox Items'
    ).trim();

    return [primaryText, secondaryText].filter(Boolean).slice(0, 2);
  }

  function applyNextTitle() {
    const hiddenTitles = getHiddenTitles();

    if (hiddenTitles.length === 0) {
      return;
    }

    document.title = hiddenTitles[titleIndex % hiddenTitles.length];
    titleIndex += 1;
  }

  function stopRotation() {
    if (titleStartTimeout) {
      clearTimeout(titleStartTimeout);
      titleStartTimeout = null;
    }

    if (titleInterval) {
      clearInterval(titleInterval);
      titleInterval = null;
    }

    titleIndex = 0;
    document.title = originalTitle;
  }

  function startRotation() {
    if (titleInterval || titleStartTimeout) {
      return;
    }

    titleStartTimeout = window.setTimeout(() => {
      titleStartTimeout = null;
      applyNextTitle();
      titleInterval = window.setInterval(applyNextTitle, intervalMs);
    }, startDelayMs);
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      startRotation();
    } else {
      stopRotation();
    }
  });

  window.addEventListener('focus', stopRotation);
})();
